<div class="doc-thumb doc-thumb--placeholder">
    <div class="doc-thumb__image"></div>
    <div class="doc-thumb__title"><div class="placeholder placeholder--120"></div></div>
    <div class="doc-thumb__subtitle"><div class="placeholder placeholder--50"></div></div>
</div>
